import { HasChildren } from '@eppendorf/vnls-react-components';
import { ReactNode } from 'react';

export function CookieElementWrapper({ children }: HasChildren): ReactNode {
  return import.meta.env.PUBLIC_ONE_TRUST_ID ? children : null;
}
